import styled from 'styled-components';
import { Button } from '@/components/atoms/Buttons/Button/styles';

export const ButtonHover = styled(Button)`
  transition: opacity 0.2s;
  :hover {
    opacity: 0.8;
  }
`;
